export const socialMedia = {
    linkedin: 'https://www.linkedin.com/in/yuchunwu/',
    github: 'https://github.com/yuchun9508'
}

export default {
    socialMedia
}